import type {Component, Editor} from 'grapesjs';
import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';

export type ColorChangeHandler = (color: string, component: Component, editor: Editor) => void;

export interface ColorControlDescriptor {
  property: string;
  labelKey: string;
  isDeletable?: boolean;
  isTextColor?: boolean;
  onColorChange?: ColorChangeHandler;
  defaultColor?: string;
  noteKey?: string;
}

export const DEFAULT_COLOR = 'FFFFFF';

export const TEXT_BASED_COMPONENT_TYPES = new Set<string>([
  EMAIL_MAKER_COMPONENT_TYPES.text.PMW_TEXT,
  EMAIL_MAKER_COMPONENT_TYPES.default.TEXT,
  EMAIL_MAKER_COMPONENT_TYPES.text.PMW_BUTTON,
]);
